import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsVoiceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_voice"}/>
}
